module.exports = __webpack_public_path__ + "img/Smart_city.56f38ebf.jpg";